<template>
    <v-card class="rules-item">
        <v-btn class="rules-item__close-icon"
               @click="closeItem"
               absolute
               x-small
               fab
               top
               right
               color="secondary">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="rules-item__row">
            <div class="rules-item__label">
                <div class="title__icon-container">
                    <v-img :src="require(`@/assets/img/icons/desc--white.svg`)" class="title__icon">
                    </v-img>
                </div>
                <p class="rules-item__title">Messages</p>
            </div>
            <div class="rules-item__select">
                <v-select
                        v-model="form.input.type"
                        :items="filterOptions"
                        label="Select rule"
                        :append-icon="'mdi-chevron-down'">
                    <template v-slot:selection="{ item }">
                        <span class="custom-value">
                            {{item.text}}
                        </span>
                    </template>
                </v-select>
            </div>
        </div>
        <RuleValue v-model="form.input.value"
                   :isMessagesInput="true"
                   :options="form.input.type === 'people-talk' ? ['greater-than', 'less-than', 'between']:['any-of', 'all-of']"
                   :autocomplete="interaction_type(form.input.type) ? userAutoComplete:[]">
        </RuleValue>
    </v-card>
</template>

<script>
    import RuleValue from "./RuleValue";
    import {store} from "../../../store/store";
    import axios from "axios";

    export default {
        name: "Messages",
        components: {RuleValue},
        props: ['value', 'uid'],
        data: () => ({
            form: {
                input:
                    {
                        value: null,
                        type: null
                    },
                type: "Messages",
            },
            filterOptions: [
                {
                    text: 'contains',
                    value: 'contains',
                },{
                    text: 'does not contain',
                    value: 'does-not-contain',
                }, {
                    text: 'in reply to',
                    value: 'in-reply-to',
                },  {
                    text: 'not in reply to',
                    value: 'not-in-reply-to',
                }, {
                    text: 'retweets',
                    value: 'is-retweet-of',
                }, {
                    text: 'does not retweet',
                    value: 'is-not-retweet-of',
                }, {
                    text: 'quotes',
                    value: 'quotes',
                }, {
                    text: 'does not quote',
                    value: 'does-not-quote',
                }, {
                    text: 'from',
                    value: 'authored-by',
                },{
                    text: 'not from',
                    value: 'not-authored-by',
                },
                {
                    text: 'from people who publish',
                    value: 'people-talk',
                }
            ],
        }),
        mounted() {
            if (this.value) {
                this.form = this.value;
            }
        },
        methods: {
            closeItem: function () {
                this.$emit('itemClosed', this.uid)
            },
            interaction_type (typ) {
                return ["is-retweet-of", "is-not-retweet-of", "quotes", 
                        "does-not-quote", "in-reply-to", "not-in-reply-to"].includes(typ)
            },
            userAutoComplete (value) {
                if (value.startsWith('@')) {
                    const token = store.state.accessToken;
                    return axios.get("/community/options/friends",
                                    {headers: {"Authorization": "Bearer " + token,
                                                "Content-type": "application/json"},
                                    params: {s: value}})
                        .then(resp => resp.data)
                } else {
                    return () => []
                }
            }
        },
        watch: {
            form: {
                handler: function (val, oldVal) {
                    if (val.input.type) {
                        this.$emit('input', val)
                    }
                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
                        this.form = val
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
